import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { fetchPsap } from '@rsos/reduxDataStore/src/features/capstone/psapInfo/psapInfoSlice';
import { fetchUser } from '@rsos/sinatra';

const CAPSTONE = 'capstone';

type LandingZonesState = {
  initializing: boolean;
  initialized: boolean;
  initError: string | null;
};

const initialState: LandingZonesState = {
  initializing: true,
  initialized: false,
  initError: null,
};

const hardRedirect = (to: string) => {
  window.location.href = to;
};

export const initialize = createAsyncThunk(
  'landingZones/initialize',
  async (_args, { dispatch, getState }: any) => {
    const isLoggedIn = getState().sinatra.user.isLoggedIn;
    return await dispatch(fetchUser())
      .then((res: any) => {
        const foundOrg = res.profile.organizations.find((org: any) => {
          const found = org.roles.find(
            (role: any) => role.application === CAPSTONE,
          );
          return !!found;
        });
        const foundRole = foundOrg.roles.find(
          (role: any) => role.application === CAPSTONE,
        );

        if (foundRole.permissions.includes('MANAGE_USERS')) {
          return dispatch(fetchPsap(`/psaps/${foundOrg.name}`));
        } else {
          throw new Error('User does not have permissions to access');
        }
      })
      .catch((err: any) => {
        if (isLoggedIn) {
          if (err) {
            throw new Error(err as string);
          }
        }
        return hardRedirect('/');
      });
  },
);

const appSlice = createSlice({
  name: 'landingZones',
  initialState,
  reducers: {},
  extraReducers: builder => {
    builder
      .addCase(initialize.pending, state => {
        state.initializing = true;
        state.initialized = false;
        state.initError = null;
      })
      .addCase(initialize.fulfilled, state => {
        state.initializing = false;
        state.initialized = true;
        state.initError = null;
      })
      .addCase(initialize.rejected, (state, { error = {} as any }) => {
        state.initializing = false;
        state.initialized = false;
        state.initError = (error as any).message as string;
      });
  },
});

export const appReducer = appSlice.reducer;
export default appReducer;
